import type { CSSProperties } from 'react';
import { BodyText, Buttons, CloseButton, DismissTextButton, TextBlock, TitleRow } from './parts';
import { COLOR_BORDER_ASSISTIVE, FONT_FAMILY, Gray900, RADIUS_MD, SHADOW_NOTICE, SP, White } from './tokens';
import type { PopupCardContent } from './types';
import { reverseWithOriginalIndex } from './utils';
export function BottomRightCard({
  content,
  onClose,
  onButtonClick,
  onDismiss
}: {
  content: PopupCardContent;
  onClose?: () => void;
  onButtonClick?: (index: number, url?: string) => void;
  onDismiss?: () => void;
}) {
  const handleClose = () => {
    onDismiss?.();
    onClose?.();
  };
  const buttons = reverseWithOriginalIndex(content.buttons);
  const containerBase: CSSProperties = {
    width: '320px',
    maxWidth: 'calc(100vw - 48px)',
    backgroundColor: White,
    border: `1px solid ${COLOR_BORDER_ASSISTIVE}`,
    borderRadius: RADIUS_MD,
    boxShadow: SHADOW_NOTICE,
    fontFamily: FONT_FAMILY,
    color: Gray900,
    overflow: 'hidden',
    pointerEvents: 'auto',
    display: 'flex',
    flexDirection: 'column'
  };
  if (content.imageUrl) {
    return <div style={containerBase}>
        <div style={{
        position: 'relative',
        alignSelf: 'stretch'
      }}>
          <img src={content.imageUrl} alt={content.title} style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          borderTopLeftRadius: RADIUS_MD,
          borderTopRightRadius: RADIUS_MD,
          objectFit: 'cover'
        }} />
          <CloseButton onClick={handleClose} style={{
          position: 'absolute',
          top: '9px',
          right: '9px'
        }} withShadow />
        </div>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        padding: SP.md,
        backgroundColor: White,
        borderBottomLeftRadius: RADIUS_MD,
        borderBottomRightRadius: RADIUS_MD
      }}>
          <TextBlock title={content.title} body={content.body} />
          <Buttons buttons={buttons} onButtonClick={onButtonClick} onClose={onClose} />
          <DismissTextButton dismissText={content.dismissText} onDismiss={onDismiss} onClose={onClose} />
        </div>
      </div>;
  }
  return <div style={{
    ...containerBase,
    padding: SP.md
  }} data-sentry-component="BottomRightCard" data-sentry-source-file="BottomRightCard.tsx">
      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '14px'
    }}>
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: SP['3xs']
      }}>
          <TitleRow title={content.title} rightSlot={<CloseButton onClick={handleClose} />} data-sentry-element="TitleRow" data-sentry-source-file="BottomRightCard.tsx" />
          {content.body && <BodyText>{content.body}</BodyText>}
        </div>
        <Buttons buttons={buttons} onButtonClick={onButtonClick} onClose={onClose} data-sentry-element="Buttons" data-sentry-source-file="BottomRightCard.tsx" />
        <DismissTextButton dismissText={content.dismissText} onDismiss={onDismiss} onClose={onClose} data-sentry-element="DismissTextButton" data-sentry-source-file="BottomRightCard.tsx" />
      </div>
    </div>;
}